import styled from 'styled-components'

export const BaseButton = styled.button`
  border-radius: 5px;
  padding: 10px 50px;
  font-size: 18px;
  border: none;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
`
